<script>
  export let practices;
  console.log(practices);
</script>

<style>
  * {
    color: white;
    text-decoration: none;
  }
  .center {
    text-align: center;
  }
  #nopractice {
    background-color: royalblue;
    width: 100%;
    height: 100%;

    position: fixed;
    top: 0;
    left: 0;
  }
  a:hover {
    text-decoration: underline;
  }
</style>

<div id="nopractice">

  <div class="center">
    <h1>Catchment Area Viewer</h1>
    <h2>Select a Practice</h2>

    {#each Object.entries(practices) as [pslug, practice]}
      <a href="/?s={pslug}">{practice.name}</a>
      <br />
    {/each}
  </div>

</div>
